import React from "react";

import { graphql, useLazyLoadQuery } from "react-relay";
import { WidgetCalendar } from "widgets/src/WidgetCalendar/WidgetCalendar";
import { WACalendarPreviewQuery } from "./__generated__/WACalendarPreviewQuery.graphql";

export function WACalendarPreview(props: { storecastId: string }) {
  const data = useLazyLoadQuery<WACalendarPreviewQuery>(
    graphql`
      query WACalendarPreviewQuery(
        $storecastId: ID!
        $input: PreviewWidgetCalendarInput!
      ) {
        dashboard(id: $storecastId) @required(action: THROW) {
          previewWidgetCalendar(input: $input) {
            ...WidgetCalendar_widgetCalendar
          }
        }
      }
    `,
    {
      storecastId: props.storecastId,
      input: {},
    }
  );
  if (!data.dashboard.previewWidgetCalendar) {
    return null;
  }
  return (
    <WidgetCalendar
      mode="IDLE"
      widget={data.dashboard.previewWidgetCalendar}
      interactive={false}
      storecastId={props.storecastId}
    />
  );
}
